import React, { useMemo } from 'react'
import { ReactFCC } from '@/types/react'

interface WatchPageContextProp {
  shouldUseBannerService: boolean
  children: React.ReactNode
}

interface WatchPageContextType {
  shouldUseBannerService: boolean
}

const WatchPageContext = React.createContext<WatchPageContextType>({
  shouldUseBannerService: false,
})

export const WatchPageContextProvider: ReactFCC<WatchPageContextProp> = ({ children, shouldUseBannerService }) => {
  const value = useMemo(() => {
    return {
      shouldUseBannerService,
    }
  }, [shouldUseBannerService])

  return <WatchPageContext.Provider value={value}>{children}</WatchPageContext.Provider>
}

export function useWatchPageContext() {
  return React.useContext(WatchPageContext)
}
